var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"otto-premium-card"},[_c('card-title',{attrs:{"plan":_vm.subscription.plan}}),_c('card-badge',{attrs:{"subscription":_vm.subscription}}),_c('card-body',{attrs:{"subscription":_vm.subscription}}),_c('span',{staticClass:"plan-cycle"},[_vm._v(_vm._s(_vm.planCycle))]),_c('card-footer',{attrs:{"subscription":_vm.subscription}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }